import requests from '../requests'

export default {
  sections: {
    list () {
      return requests.get('compliance/risk-assessment-templates/sections')
    }
  }
}
